import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LocalText from "../common/LocalText";

const PortalSlotTile = ({ onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        height: { xs: 200, sm: 220, md: 240 },
        border: "2px dashed",
        borderColor: "#c8d8ea",
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        cursor: "pointer",
        bgcolor: "white",
        transition: "all 0.2s ease",
        "&:hover": {
          bgcolor: "#EAF0F6",
          borderColor: "#5383b3",
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          bgcolor: "#EAF0F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddIcon sx={{ color: "#0a326d", fontSize: 28 }} />
      </Box>
      <Typography variant="body2" sx={{ color: "#5383b3", fontWeight: 600 }}>
        <LocalText>Add</LocalText>
      </Typography>
    </Box>
  );
};

export default PortalSlotTile;
